import Vue from "vue";
import VueRouter from "vue-router";
import Home from "../views/Home.vue";
import ChooseTheme from "../views/ChooseTheme.vue";
import StoryCreate from "../views/CreateStory.vue";
import ImportText from "../views/ImportText.vue";
import EmptyInbox from "../views/EmptyInbox.vue";
import ChatDetails from "../views/ChatDetails.vue";
import Inbox from "../views/Inbox.vue";
import Profile from "../views/Profile.vue";
import PostDetails from "../views/PostDetails.vue";
import SeriesDetails from "../views/SeriesDetails.vue";

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    name: "home",
    component: Home
  },
  {
    path: "/profile/:name",
    name: "profile",
    component: Profile
  },
  {
    path: "/choose-theme",
    name: "choose-theme",
    component: ChooseTheme
  },
  {
    path: "/about",
    name: "about",
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ "../views/About.vue")
  },
  {
    path: "/story-create",
    name: "story-create",
    component: StoryCreate,
  },
  {
    path: "/import-text",
    name: "import-text",
    component: ImportText,
  },
  {
    path: "/empty-inbox",
    name: "empty-inbox",
    component: EmptyInbox,
  },
  {
    path: "/chat-details/:id",
    name: "chat-details",
    component: ChatDetails,
  },
  {
    path: "/inbox",
    name: "inbox",
    component: Inbox,
  },
  {
    path: "/post-details",
    name: "post-details",
    component: PostDetails,
  },
  {
    path: "/series-details",
    name: "series-details",
    component: SeriesDetails,
  }
];

const router = new VueRouter({
  mode: "history",
  routes,

  
});

export default router;
